import types from '../actions/types'

const { SET_TARIFA_CLIENTE } = types

function tarifaClienteReducer(state = [], action = {}) {
  switch (action.type) {
    case SET_TARIFA_CLIENTE: {
      return action.tarifas || []
    }
    default:
      return state
  }
}

export default tarifaClienteReducer
